var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{ref:"BusinessForm",attrs:{"page-title":"Add a new Business","buttonName":"Submit","isCreateMode":true,"isInList":_vm.isInList,"loading":_vm.loading},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }